import { render } from "./MainNavSidebar.vue?vue&type=template&id=ad320104"
import script from "./MainNavSidebar.vue?vue&type=script&lang=js"
export * from "./MainNavSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__